import { createPortal } from 'react-dom';
import useLeafletControlContainer from '../hooks/useLeafletControlContainer';

const CustomLeafletControl = ({ position = 'topright', children }) => {
  const controlContainer = useLeafletControlContainer(position);

  if (!controlContainer) {
    return null;
  }

  return createPortal(children, controlContainer);
};

export default CustomLeafletControl;
